export const getStudentData = () => {
  const userJson = localStorage.getItem("ud");
  if (userJson) {
    const studentData = JSON.parse(localStorage.getItem("ud"));
    return studentData;
  } else {
    return {};
  }
};

export const setLocalStorage = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data));
};

export const getIsScreenReloaded = () => {
  const isScreenReloaded = JSON.parse(localStorage.getItem("isScreenReloaded"));
  return isScreenReloaded;
};

export const getLocalStorage = (key) => JSON.parse(localStorage.getItem(key));
